export enum EventQueryEnum {
  MainEventListUpComing = 'MainEventListUpComing',
  MainEventListPast = 'MainEventListPast',
  MainEventListCancelled = 'MainEventListCancelled',
  DashboardUpComingEvents = 'DashboardUpComingEvents',
  // VenueUpComingEvents = 'VenueUpComingEvents',
  // ArtistUpComingEvents = 'ArtistUpComingEvents',
}
